export default {
  "112340121205000": {
    "name": "杜集镇",
    "volumn": 604.82,
    "anchor": [117.364, 32.344]
  },
  "112340121104000": {
    "name": "岗集镇",
    "volumn": 2959.8,
    "anchor": [117.148, 31.992]
  },
  "112340121200000": {
    "name": "罗塘乡",
    "volumn": 29040,
    "anchor": [117.098, 32.401]
  },
  "112340121105000": {
    "name": "双墩镇",
    "volumn": 1157.31,
    "anchor": [117.255, 32.066]
  },
  "112340121400000": {
    "name": "双凤开发区",
    "volumn": 206.35,
    "anchor": [117.26, 31.97]
  },
  "112340121100000": {
    "name": "水湖镇",
    "volumn": 49860,
    "anchor": [117.145, 32.473]
  },
  "112340121202000": {
    "name": "陶楼镇",
    "volumn": 472.38,
    "anchor": [117.16, 32.12]
  },
  "112340121103000": {
    "name": "吴山镇",
    "volumn": 640.59,
    "anchor": [117.064, 32.088]
  },
  "112340121106000": {
    "name": "下塘镇",
    "volumn": 201.19,
    "anchor": [117.21, 32.213]
  },
  "112340121102000": {
    "name": "杨庙镇",
    "volumn": 1626.15,
    "anchor": [117.07, 32.187]
  },
  "112340121201000": {
    "name": "义井镇",
    "volumn": 936.43,
    "anchor": [117.115, 32.28]
  },
  "112340121203000": {
    "name": "造甲乡",
    "volumn": 242.52,
    "anchor": [117.319, 32.24]
  },
  "112340121107000": {
    "name": "朱巷镇",
    "volumn": 393.85,
    "anchor": [117.244, 32.33]
  },
  "112340121101000": {
    "name": "庄墓镇",
    "volumn": 768,
    "anchor": [117.08, 32.344]
  },
  "112340121204000": {
    "name": "左店镇",
    "volumn": 20560,
    "anchor": [117.235, 32.404]
  }
}



// WEBPACK FOOTER //
// ./src/components/volumn-towns.js